import { Component, OnInit, OnDestroy, ViewChild, ElementRef, AfterViewInit, HostListener } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd, RouterEvent } from '@angular/router';
import { ApiService } from '../../../services/api.service';
import { AppService } from '../../../services/app.service';
import { filter, takeUntil } from 'rxjs/operators';
import { GtagService } from '../../../services/gtag.service';
import { FbService } from '../../../services/fb.service';
import { Subscription, Subject } from 'rxjs';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { CartService } from 'src/app/services/cart.service';

declare var $:any;
declare var window:any;

@Component({
  selector: 'servico-page', 
  templateUrl: './servico-page.component.html', 
  styleUrls: ['./servico-page.component.scss'] 
})
export class ServicoPage implements OnInit,OnDestroy, AfterViewInit {

  @ViewChild("sliderRelacionados") sliderRelacionados:ElementRef;
  public apelido = null;
  public produto = null;
  public categoria = null;
  public fotos   = [];
  public loader  = false;
  public messageLoader = "Carragendo Serviço...";
  public response      = {      
    data: "",
    status: null
  }
  public macro_regiao      = [];  
  public regiao:any            = {};
  public configuracao_loja = null;
  public ultimoServicoInserido   = null;
  public produtos_relacionados   = [];
  public mySubscription:Subscription;
  public destroyed               = new Subject<any>();
  public destroy                 = false;
  public itensBreadcrumbs        = [];
  public dias                    = null; 
  public contentDescricao        = 1; 
  public incluso                 = [];
  public naoIncluso              = [];
  public avaliacaoMedia          = null;
  public avaliacaoMediaData      = null;
  public avaliacaoMediaItens     = [];
  public addCart                 = false;
  public show                    = false;
  public isSendAnalytics         = false;
  public cidades                 = [];
  public showAllRoteiro          = false;
  public showAllInformacoes      = false;
  public isMobile                = false;
  public horarios                = [];
  public idCart                  = null;
  public email                   = null;
  public emailSugestao           = null;
  public emailStatus:any         = false; 
  public showInfoGeral           = false;
  public tokenRecaptcha          = null;
  public servicoCart             = null;
  public isFavorito              = false;
  public caracteristicas         = [];
  public textos  = [];
  public duvidas = [];
  public width = 0;
  public avaliacao:any = {
    nota: 0,
    total: 0,
    lista: []
  }
  public lp = null;

  constructor(
    private route: ActivatedRoute,
    private api: ApiService,
    private router: Router,
    private app: AppService,
    private gtag: GtagService,
    private cart: CartService
  ){

    this.apelido = typeof(this.route.params["_value"].apelido_produto) != "undefined" ? this.route.params["_value"].apelido_produto : null;
    this.lp      = this.route.params['_value'].apelido || null;

  }
  /**
   * 
   * Retorna os dados do produto baseado no apelido
   * 
   * 
   */
  getData(){

    try{

      this.loader           = true;
      this.response.status  = null; 
      this.itensBreadcrumbs = [];   

      this.api.produto().produto(this.apelido,this.lp).subscribe(response => {

        try{
          
          this.loader = false;

          if(response.status == 1){

            if(response.data.produto == null){ 
              this.router.navigateByUrl("/");   
            }
            this.addCart               = false;
            this.produto               = response.data.produto;
            this.textos                = response.data.textos;
            this.fotos                 = response.data.fotos;
            this.categoria             = response.data.categoria; 
            this.macro_regiao          = response.data.macro_regiao;
            this.dias                  = response.data.dias;
            this.configuracao_loja     = response.data.configuracao_loja;
            this.ultimoServicoInserido = response.data.servico; 
            this.produtos_relacionados = response.data.relacionados;
            this.response.status       = 1; 
            this.cidades               = response.data.cidades; 
            this.horarios              = response.data.horarios; 
            this.idCart                = response.data.id;
            this.email                 = response.data.email;
            this.emailSugestao         = response.data.email_sugestao;
            this.servicoCart           = response.data.servico_cart;
            this.isFavorito            = response.data.is_favorito;
            this.caracteristicas       = response.data.caracteristica; 
            this.duvidas               = response.data.duvidas;
            this.avaliacao             = response.data.avaliacao;  
 
            this.emailStatus = response.data.email_status === 1 || response.data.email_status === "1" ? 1 : 0;

            if(this.emailStatus){
              this.configuracao_loja.solicitar_email_pre_venda = true;
            }
                 
            this.setContentDescricao();       
            this.setItensBreadcrumbs();      
  
            this.app.setMetaDados(this.produto.meta_title,this.produto.meta_description);

            this.app.toTop();

            setTimeout(() => {
              this.gtag.viewItem({   
                id: this.produto.id,
                nome: this.produto.nome,  
                categoria: this.categoria.titulo 
              }); 
            },800);
            
          }else{
            this.response = response;
          }

          setTimeout(() => {
            this.app.toTop();
          },500);

        }catch(e){

          
          
        }  

      },(response) => {

        this.loader = false;
        let error   = this.app.formatError(response);

        this.response = {
          data: error.message,
          status: 500
        }

        setTimeout(() => {
          this.app.toTop();
        },500);

      });

    }catch(e){

      this.loader = false;

    }

  }
  /**
   * 
   * Formata os dias
   * 
   */
  formatDias(dias){

    let result = null;

    if(dias != null){

      result = "";

      for (let index = 0; index < dias.length; index++) {
        
        if(index > 0){
          result += ", ";
        }
        result += dias[index].descricao;
        
      }

    }
    
    return result;

  }
  /***
   * 
   * Seta os breadcrumbs
   * 
   */
  setItensBreadcrumbs(){  

    this.itensBreadcrumbs.push({
      text: "Serviços",
      routerLink: "/servicos"
    });
    this.itensBreadcrumbs.push({
      text: this.categoria.titulo,
      routerLink: "/servicos/"+this.categoria.apelido 
    });
    this.itensBreadcrumbs.push({
      text: this.produto.nome
    });

  }
  /**
   * 
   * Ouvinte
   * 
   */
  onData(){

    this.app.emitChangePage.subscribe(response => {

      let apelido = typeof(response.apelido) != "undefined" ? response.apelido : null;

      if(apelido != null){

        if(apelido != this.apelido){

          this.apelido = apelido;
          this.getData();

        }

      }

    });
    this.cart.emitirAddItem.subscribe((item) => {

      this.servicoCart = item; 

    });

  }
  /**
   * 
   * Separa as características
   * 
   */
  separaCaracterisitcas(caracteristicas){
    
    let incluso    = [];
    let naoIncluso = [];

    for (let index = 0;index < caracteristicas.length;index++) {
      
      if(caracteristicas[index].tipo == 1){
        incluso.push({
          descricao: caracteristicas[index].descricao
        });
      }else{
        naoIncluso.push({
          descricao: caracteristicas[index].descricao
        });
      }
      
    }

    this.incluso    = incluso; 
    this.naoIncluso = naoIncluso;

  }
  /***
   * 
   * Inicializa o Slider
   * 
   */
  initSliderRelacionados(){

    $(this.sliderRelacionados.nativeElement).slick({
      infinite: true,
      slidesToShow: 4,
      dots: true,
      arrows: false,
      centerMode: true,
      centerPadding: '60px',
      responsive: [{
          breakpoint: 1224,
          settings: {
              slidesToShow: 3,
          }
      },

      {
          breakpoint: 1024,
          settings: {
          slidesToShow: 2,
        }
      },
      {
          breakpoint: 768,
          settings: {
              slidesToShow: 1,

          }
      },
      {
          breakpoint: 540,
          settings: {
            slidesToShow: 1,
            centerPadding: '0',
          }
      }
      ]
    
    });

  }
  /**
   * 
   * Prev
   * 
   */
  prevSlider(){
    
    $(this.sliderRelacionados.nativeElement).slick("prevPrev");

  }
  /**
   * 
   * Next
   * 
   */
  nextSlider(){

    $(this.sliderRelacionados.nativeElement).slick("slickNext");

  }
  /**
   * 
   * Inicializa as Funções
   * 
   */
  ngOnInit(){

    this.app.toTop();
    this.getData();
    this.onData();
    this.addCart = false;

    this.mySubscription = this.router.events.pipe(
      filter((event:RouterEvent) => event instanceof NavigationEnd),
      takeUntil(this.destroyed)
    ).subscribe(() => {
      
      if(!this.destroy){
        this.apelido = this.route.params["_value"].apelido_produto;
        this.getData();
      }  

    });


  }
 
  /***
   * 
   * Set content descrição
   * 
   */
  setContentDescricao(){

    if(this.produto.mostrar_descricao){  
      this.contentDescricao = 1;
    }else if(this.produto.mostrar_duracao){
      this.contentDescricao = 2;
    }else if(this.produto.mostrar_incluso){
      this.contentDescricao = 3;
    }else if(this.produto.mostrar_nao_incluso){
      this.contentDescricao = 4;
    }else if(this.produto.mostrar_observacao){
      this.contentDescricao = 5;
    }else if(this.produto.mostrar_dica){
      this.contentDescricao = 6;
    }else if(this.produto.mostrar_informacao){
      this.contentDescricao = 7;
    }

  }
  /**
   * 
   * Show all roteiro
   * 
   */
  _showAllRoteiro(){  

    this.showAllRoteiro = this.showAllRoteiro == true ? false : true;  

  } 
  /**
   * 
   * Show all roteiro
   * 
   */
  _showAllInformacoes(){

    this.showAllInformacoes = this.showAllInformacoes == true ? false : true; 

  } 
  /**
   * 
   * Destroy
   * 
   * 
   */
  ngOnDestroy() {
    
    if(this.mySubscription){
      
      this.destroy         = true;
      this.addCart         = false;
      this.isSendAnalytics = false;
      this.mySubscription.unsubscribe(); 
    
    }

  }
  /***
   * 
   * Send analytics
   * 
   */
  sendAnalytics(){

    if(!this.isSendAnalytics){
      this.isSendAnalytics = true;
      setTimeout(() => {
      
        this.gtag.sendPage(); 

      },500);

    }

  }
  /***
   * 
   * Add Cart
   * 
   */
  _addCart(){ 

    this.addCart = true;

  }
  /**
   * 
   * Seta o content
   * 
   * @param largura 
   * 
   */
  setContent(largura){

    if(largura <= 500){
      this.isMobile = true;
    }else{
      this.isMobile = false;
    }

  }
  /**
   * 
   * Show info geral
   * 
   */
  _showInfoGeral(){

    this.showInfoGeral = this.showInfoGeral == true ? false : true;

  }
  /**
   * 
   * On Resize 
   * 
   * @param event 
   * 
   */
  @HostListener('window:resize', ['$event'])
  onResize(event) {   
    this.setContent(event.target.innerWidth);
  }
  /**
   * 
   * Inicializa as Funções
   * 
   */
  ngAfterViewInit(): void {
    
    this.width = window.innerWidth;
    this.app.loadEnd();
    this.setContent(window.innerWidth);
    this.show = true;
    
  }

}
